import script from "./BrainstormView.vue?vue&type=script&setup=true&lang=js"
export * from "./BrainstormView.vue?vue&type=script&setup=true&lang=js"

import "./BrainstormView.vue?vue&type=style&index=0&id=ed90f30a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed90f30a"]])

export default __exports__